import React from 'react';
import dayjs from 'dayjs';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export default function PostListItem({ item }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <article
      onClick={() => {
        dispatch(CommonActions.increaseStep());
        const prefix = item.prefix || 'N';
        navigate(`/M_Post/detail/${prefix}${item.chaebun}`);
      }}
      className="shadow-soft cursor-pointer rounded-2xl bg-white p-5 transition-transform active:scale-[0.99]"
    >
      {/* 배지 */}
      <div className="mb-1 flex gap-2">
        {item?.prefix === 'P' && (
          <span className="rounded bg-yellow-400/20 px-2 py-0.5 text-[11px] font-bold text-yellow-700">
            안전보건경영방침
          </span>
        )}
        {item?.prefix === 'E' && (
          <span className="rounded bg-rose-400/20 px-2 py-0.5 text-[11px] font-bold text-rose-700">
            비상대응메뉴얼
          </span>
        )}
      </div>

      {/* 제목 */}
      <p className="mb-2 line-clamp-2 text-base leading-snug font-bold text-slate-800">
        {item.prefix === 'P' && !item.title
          ? '안전보건경영방침'
          : item.prefix === 'E' && !item.title
            ? '비상대응메뉴얼'
            : item.title || '제목 없음'}
      </p>

      {/* 메타 정보 */}
      <div className="flex items-center text-xs font-medium text-slate-400">
        <span>{item.createId}</span>
        <span className="mx-1.5 h-2.5 w-px bg-slate-200" />
        <span>{dayjs(item.updateDate).format('YYYY-MM-DD')}</span>
      </div>
    </article>
  );
}
